var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChoose = function SvgChoose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 449 315",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "choose_svg__a",
    d: "M.71.47h57.28v91.52H.71z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "choose_svg__c",
    d: "M.22.33h137.15v34.29H.22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "choose_svg__e",
    d: "M.88.47h57.28v91.52H.88z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "choose_svg__g",
    d: "M.2.47h57.28v91.52H.2z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 198.5h429",
    stroke: "#12186D",
    strokeWidth: 6.36,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    strokeWidth: 1.45,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M264 188h-53l3.872-23h45.247z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#55F99F",
    fillRule: "nonzero",
    d: "M262 186h-53l3.881-23h45.247z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    strokeWidth: 1.45,
    fill: "#12186D",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M273 197h-70l7.831-8h53.473z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.953 239.998H170.284a3.273 3.273 0 0 1-2.555-1.1 3.243 3.243 0 0 1-.775-2.663l3.6-19.272a3.336 3.336 0 0 1 3.339-2.643H307.66a3.335 3.335 0 0 1 3.347 2.687l3.294 19.282a3.252 3.252 0 0 1-.808 2.63 3.283 3.283 0 0 1-2.54 1.08h0ZM371.447 10H146.526c-3.052 0-5.526 2.463-5.526 5.501v153.213c0 2.534 2.063 4.588 4.608 4.588h226.784c2.545 0 4.608-2.054 4.608-4.588V15.501a5.49 5.49 0 0 0-1.628-3.9 5.539 5.539 0 0 0-3.925-1.6h0Z",
    stroke: "#12186D",
    strokeWidth: 1.45,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135 153h235v14.664a6.33 6.33 0 0 1-6.327 6.336H141.327a6.332 6.332 0 0 1-6.327-6.336V153Z",
    stroke: "#12186D",
    strokeWidth: 1.45,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.555 12h219.854c2.013 0 3.944.792 5.368 2.201A7.48 7.48 0 0 1 370 19.516V153H135V19.516c0-4.137 3.377-7.496 7.555-7.516Z",
    stroke: "#12186D",
    strokeWidth: 1.45,
    fill: "#12186D",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    strokeWidth: 1.45,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M143 18h218v127H143z"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#12186D",
    strokeWidth: 1.45,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 237.5,
    cy: 160.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#55F99F",
    fillRule: "nonzero",
    cx: 236.5,
    cy: 160.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.005 64.691c.483.68 1.146 1.656 1.907 2.846 1.791 2.864 1.917 3.392 1.899 3.794-.09 2.05-2.991 3.437-3.806 3.795V64.69Zm118.448 108.541c.794 4.815 1.585 9.632 2.373 14.453l-2.373 1.79-2.821-16.252 2.82.01Zm2.373 14.453 10.908 8.626-10.908-8.626Z",
    stroke: "#12186D",
    strokeWidth: 1.45,
    fill: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.344 150.95c-5.58-.108-10.156 26.175-11.75 35.356-3.52 20.216-6.108 49.022-1.325 85.06a15.315 15.315 0 0 0 7.012 8.107 19.115 19.115 0 0 0 12.896 1.88 273.765 273.765 0 0 0 5.248-81.355c-1.531-17.62-6-48.932-12.08-49.049h0Z",
    stroke: "#12186D",
    strokeWidth: 1.45,
    fill: "#55F99F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.85 243.865c4.147-.519 9.851-1.79 14.562-5.28a21.127 21.127 0 0 0 5.096-5.27c2.427-3.49 7.845-8.108 21.108-12.904a31.295 31.295 0 0 1 13.828 2.344 2.1 2.1 0 0 1 .725 1.172 2.353 2.353 0 0 1-1.45 2.345 4.102 4.102 0 0 1 2.91 1.79c.385.734.385 1.61 0 2.344a7.014 7.014 0 0 1 3.636 1.79 4.634 4.634 0 0 1 1.46 2.926l5.096 1.173a2.58 2.58 0 0 1 2.185 1.172 1.79 1.79 0 0 1-.725 2.345c-1.44.307-2.901.504-4.37.59a30.85 30.85 0 0 1-3.646 0 349.174 349.174 0 0 1-8.006 5.28c-7.729 4.949-11.643 7.455-15.288 8.797a42.749 42.749 0 0 1-17.463 2.344l-11.643 1.79-8.015-14.748h0Z",
    stroke: "#12186D",
    strokeWidth: 1.45,
    fill: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.719 226.272a21.751 21.751 0 0 0-4.37-.582 22.137 22.137 0 0 0-5.822.582m13.102 4.108a18.561 18.561 0 0 0-4.37 0c-.985.115-1.959.313-2.91.59m12.376 4.099h-2.687a4.275 4.275 0 0 0-1.79.385l-4.264 1.96",
    stroke: "#12186D",
    strokeWidth: 1.45,
    fill: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.592 131.27c5.042 1.307 11.705 3.777 16.747 8.798a24.416 24.416 0 0 1 6.547 11.732c2.955 11.544 12.69 47.634 25.479 96.755l37.121-6.443 10.926 18.175a1094.23 1094.23 0 0 1-48.047 15.83c-12.619 3.84-20.222 5.897-26.93 2.935-9.117-4.018-10.604-14.64-10.926-18.175l-16.013-55.125c1.702-24.824 3.4-49.65 5.096-74.481h0Z",
    stroke: "#12186D",
    strokeWidth: 1.45,
    fill: "#55F99F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.309 314.329c2.158-30.99 3.35-56.772 5.508-87.762.313-8.224.403-16.77.206-25.62a429.515 429.515 0 0 0-6.565-66.07c-7.582-3.44-15.1-7.02-22.55-10.738a635.477 635.477 0 0 1-9.046-4.636l-45.1-1.118s-17.016 8.564-32.456 16.492c-16.389 8.385-25.971 23.58-24.86 39.572.608 8.69 1.566 17.298 1.566 26.775 0 43.187 2.517 95.574 3.412 112.657",
    stroke: "#12186D",
    strokeWidth: 1.45,
    fill: "#55F99F",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.439 115.44a39.891 39.891 0 0 0 17.096-5.691c13.192-8.242 17.016-22.14 18.046-26.578a43.325 43.325 0 0 0 .985-12.314l-.95-43.661c-.671-4.018-2.552-11.32-8.543-17.084-10.747-10.318-26.41-7.866-34.202-6.649-3.878.609-22.21 3.472-33.243 18.98a45.724 45.724 0 0 0-5.705 11.393c-8.616 22.846-2.374 43.715 0 51.259 2.301 7.32 3.457 10.98 6.654 15.213 9.403 12.448 26.294 16.734 39.862 15.132h0Z",
    stroke: "#12186D",
    strokeWidth: 1.45,
    fill: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.25 15.777s2.776-7.383 1.155-14.318c0 0-13.236 3.373-23.285 4.975a35.43 35.43 0 0 0-3.34-1.682 62.696 62.696 0 0 1 5.839-3.759 110.328 110.328 0 0 0-21.583 1.146c-1.084.098-2.257.215-3.583.358C98.79 3.535 87.291 4.76 77.11 12.94 68.52 19.83 65.072 28.36 62.86 33.818c-5.553 13.754-4.567 25.88-3.797 34.175a90.721 90.721 0 0 0 6.654 26.579 81.347 81.347 0 0 0 22.792 3.794c8.06.17 16.56.34 19.953-4.743 1.263-1.906 1.174-4.474.95-9.495-.976-21.405-1.245-22.971 0-25.63a14.946 14.946 0 0 1 3.582-4.769c2.868.08 5.738-.042 8.589-.367 19.389-2.309 36.243-13.611 38.509-38.525l-6.842.94Z",
    fill: "#12186D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.287 70.857c2.579-.77 4.925 3.257 9.502 5.692 4.065 2.165 10.917 3.58 22.792-.949a42.87 42.87 0 0 1-.95 7.598 41.151 41.151 0 0 1-8.543 18.032 39.889 39.889 0 0 1-26.599 14.21 32.967 32.967 0 0 0 3.798-12.34 33.698 33.698 0 0 0-3.798-18.98c.08-5.37.699-12.341 3.798-13.263Z",
    fill: "#12186D",
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.636 53.085a9.859 9.859 0 0 0-1.79.116c-5.441.843-9.299 5.753-8.827 11.235.472 5.48 5.113 9.66 10.617 9.562m-55.095 26.283c-2.848 8.233-3.797 9.844-6.654 18.04l44.653.95 5.696-18.99",
    stroke: "#12186D",
    strokeWidth: 1.45,
    fill: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.986 135.405 4.111 1.647c3.504 12.027 7.003 24.054 10.496 36.082-.197 10.738-.397 21.456-.6 32.153-.34 4.027-.683 8.048-1.03 12.063h-9.77a235.68 235.68 0 0 1-3.162-81.945h-.045Z",
    fill: "#55F99F"
  }))), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M296.71 46.47h57.28v91.52h-57.28z"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#12186D",
    fontFamily: "Helvetica",
    fontSize: 10.57,
    transform: "translate(163 25)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 152.44,
    y: 34.15
  }, "FELIX")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(296 47)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "choose_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#choose_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#choose_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-96 -16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.49 78.31a14.17 14.17 0 0 0 11.91-1.79 13.9 13.9 0 0 0 5.54-8.82c.54-.11 5.49-1.19 7.54-5.71 1.88-4.15.5-9.46-3.56-12.72 3.43-4.71 4.05-10.58 1.55-15A12.66 12.66 0 0 0 84.32 29c.23-.75 2-6.72-1.68-11.51A11.44 11.44 0 0 0 78.21 14c1.5-5.16-.46-9.9-3.72-11.27a7.25 7.25 0 0 0-5.54.36 4.47 4.47 0 0 0-8.52 1.1c-.29 0-4.4.24-6.39 3.68a7.46 7.46 0 0 0-.82 5 10.53 10.53 0 0 0-7.22 8 9.6 9.6 0 0 0 1 5.84 10.39 10.39 0 0 0-5.58 6.22 10.56 10.56 0 0 0 1.79 9.2A12 12 0 0 0 38.06 54a11.82 11.82 0 0 0 5 7.41c-2.09 4.11-1.22 8.85 1.8 11.36s7.21 1.69 7.71 1.57c.28.5 2.85 4.94 8 5.58a10.73 10.73 0 0 0 6.92-1.61h0Z",
    stroke: "#12186D",
    strokeWidth: 0.25,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    strokeWidth: 0.25,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M63.26 64.62h4.02v64.77h-4.02zM63.91 25a3.51 3.51 0 0 0-4.51-.85A3.41 3.41 0 0 0 58 27.4a4.1 4.1 0 0 0-5.73 4.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.74 63.43a3.49 3.49 0 0 0 3.5 2.95 3.39 3.39 0 0 0 2.84-2.15A4.14 4.14 0 0 0 69 66a4.19 4.19 0 0 0 3.47-3.12M69.45 45a3.51 3.51 0 0 0 4.48 1 3.41 3.41 0 0 0 1.52-3.22 4.1 4.1 0 0 0 5.89-4.65",
    stroke: "#12186D",
    strokeWidth: 0.25,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9 78.31a14.19 14.19 0 0 0 11.92-1.79 13.83 13.83 0 0 0 5.53-8.82c.55-.11 5.5-1.19 7.54-5.71 1.88-4.15.51-9.46-3.55-12.72 3.43-4.71 4.05-10.58 1.54-15A12.57 12.57 0 0 0 87.73 29c.24-.75 2-6.72-1.67-11.51A11.46 11.46 0 0 0 81.62 14c1.51-5.16-.46-9.9-3.72-11.27a7.22 7.22 0 0 0-5.53.36 4.47 4.47 0 0 0-8.52 1.1c-.3 0-4.41.24-6.39 3.68a7.4 7.4 0 0 0-.82 5 10.54 10.54 0 0 0-7.23 8 9.68 9.68 0 0 0 1 5.84 10.35 10.35 0 0 0-5.57 6.22 10.56 10.56 0 0 0 1.79 9.2A12 12 0 0 0 41.48 54a11.82 11.82 0 0 0 5 7.41c-2.09 4.11-1.21 8.85 1.8 11.36s7.22 1.69 7.71 1.57c.28.5 2.85 4.94 8.05 5.58a10.67 10.67 0 0 0 6.86-1.61Z",
    fill: "#55F99F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.84 129.56C11.06 117 18 109.51 18 109.51 7.11 115 8 129.56 8 129.56h7.84Z",
    stroke: "#12186D",
    strokeWidth: 0.25,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.58 129.6c-3.4-9 1.56-14.28 1.56-14.28-7.76 3.91-7.12 14.28-7.12 14.28h5.56Z",
    stroke: "#12186D",
    strokeWidth: 0.25,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.37 129.53c-2.09-5.5.95-8.77.95-8.77-4.76 2.4-4.37 8.77-4.37 8.77h3.42ZM49.05 124.55a3.31 3.31 0 0 0-1.84-3.14v-.23a3.18 3.18 0 0 0-2.94-3.4 2.51 2.51 0 0 0-.55 0 355.892 355.892 0 0 1-3.92-2.7 3 3 0 0 0-2.51 1.25 2.89 2.89 0 0 0-1.17-.3 3 3 0 0 0-2 .68 2.75 2.75 0 0 0-1.11-.27 3.16 3.16 0 0 0-3.15 2.8 3.29 3.29 0 0 0-2.31 3.08 3.51 3.51 0 0 0 .49 1.91 3.4 3.4 0 0 0-.62 1.87 3.19 3.19 0 0 0 2.94 3.41h.17l15.23.07a3.2 3.2 0 0 0 3.18-3.19 3.66 3.66 0 0 0-.09-.94 4 4 0 0 0 .2-.9h0Z",
    stroke: "#12186D",
    strokeWidth: 0.25,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.93 124.78a1.83 1.83 0 0 0-.34-1.58 1.63 1.63 0 0 0-.89-1.55 1.55 1.55 0 0 0-1.3 0l-.14-.07a1.66 1.66 0 0 0-2 .56M35.1 124.43a1.42 1.42 0 0 0-1.06-.69 1.28 1.28 0 0 0-1.35-.38 1.19 1.19 0 0 0-.71.74h-.12a1.32 1.32 0 0 0-.8 1.41M45.64 129.57a25.37 25.37 0 0 0 12.13-6.69c5.11-5 9.22-13.37 7.38-15.73-1.42-1.82-6.06.37-6.7.68-9.43 4.46-12.23 18.46-12.81 21.74",
    stroke: "#12186D",
    strokeWidth: 0.25,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.64 129.57a26.39 26.39 0 0 1 6-7.87 23.25 23.25 0 0 1 4.15-3",
    stroke: "#12186D",
    strokeWidth: 0.25,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.82 121.44c.9-5.24 1.5-8.76 1.39-13.3-.11-4.54-1-13.82-3.2-14-2.2-.18-5.25 8.12-5.69 16-.56 10.15 3.44 19.77 5.32 19.45.8-.16 1.26-2.83 2.18-8.15h0Z",
    stroke: "#12186D",
    strokeWidth: 0.25,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.64 129.57a34.18 34.18 0 0 1-1.52-7.63 35.4 35.4 0 0 1 .4-9M45 129.56a10.88 10.88 0 0 1-5.24-2.88c-2.2-2.19-4-5.78-3.18-6.8.61-.79 2.61.16 2.89.29 4.07 1.93 5.28 8 5.53 9.39",
    stroke: "#12186D",
    strokeWidth: 0.25,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 129.56a10.8 10.8 0 0 0-4.37-4.68",
    stroke: "#12186D",
    strokeWidth: 0.25,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.09 126.05a27.342 27.342 0 0 1-.6-5.74c.05-2 .45-6 1.39-6.05.94-.05 2.26 3.51 2.45 6.9.24 4.39-1.48 8.54-2.3 8.4-.34-.06-.54-1.21-.94-3.51h0Z",
    stroke: "#12186D",
    strokeWidth: 0.25,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 129.56a14.37 14.37 0 0 0 .66-3.29 15.74 15.74 0 0 0-.17-3.88M103.14 70.57a20 20 0 0 1-9.56-5.27c-4-4-7.26-10.53-5.81-12.39 1.12-1.44 4.77.29 5.27.53 7.43 3.52 9.64 14.55 10.1 17.13",
    stroke: "#12186D",
    strokeWidth: 0.25,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.14 70.57a21.05 21.05 0 0 0-4.72-6.2 18.81 18.81 0 0 0-3.27-2.34",
    stroke: "#12186D",
    strokeWidth: 0.25,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.42 64.16a50.09 50.09 0 0 1-1.1-10.47c.09-3.63.83-10.89 2.53-11 1.7-.11 4.13 6.4 4.47 12.58.45 8-2.7 15.57-4.18 15.32-.64-.13-1-2.23-1.72-6.43h0Z",
    stroke: "#12186D",
    strokeWidth: 0.25,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.14 70.57a27.14 27.14 0 0 0 1.19-6 28.12 28.12 0 0 0-.31-7.07M103.61 70.56a8.63 8.63 0 0 0 4.13-2.27c1.74-1.72 3.14-4.55 2.51-5.35-.48-.62-2.06.12-2.28.23-3.21 1.51-4.16 6.28-4.36 7.39",
    stroke: "#12186D",
    strokeWidth: 0.25,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.61 70.56a9.09 9.09 0 0 1 2-2.67 8 8 0 0 1 1.41-1",
    stroke: "#12186D",
    strokeWidth: 0.25,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.35 67.8a21.45 21.45 0 0 0 .48-4.53c0-1.57-.36-4.7-1.09-4.76-.73-.06-1.74 2.77-1.94 5.49-.19 3.45 1.17 6.72 1.81 6.61.27-.09.39-1 .74-2.81h0Z",
    stroke: "#12186D",
    strokeWidth: 0.25,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.61 70.56a11.14 11.14 0 0 1-.51-2.59 11.91 11.91 0 0 1 .13-3.06",
    stroke: "#12186D",
    strokeWidth: 0.25,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    strokeWidth: 0.25,
    fill: "#12186D",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m80.82 69.75-18.74 56.59H.2v5.61h177.03v-62.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    strokeWidth: 0.25,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m87.42 69.75-18.75 56.59H6.79v5.61H271.19v-62.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.85 132.21H72.63l16.12-50.06a9.28 9.28 0 0 1 8.83-6.43h154.47l-18.2 56.49Z",
    fill: "#55F99F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.91 125.47 13.46-41.79a7.72 7.72 0 0 1 7.36-5.36M96.72 125.47l13.46-41.79a7.72 7.72 0 0 1 7.36-5.36M110.53 125.47 124 83.68a7.74 7.74 0 0 1 7.37-5.36M124.34 125.47l13.46-41.79a7.74 7.74 0 0 1 7.37-5.36M138.16 125.47l13.45-41.79a7.74 7.74 0 0 1 7.37-5.36M152 125.47l13.46-41.79a7.72 7.72 0 0 1 7.36-5.36M165.78 125.47l13.46-41.79a7.72 7.72 0 0 1 7.36-5.36M179.59 125.47l13.46-41.79a7.74 7.74 0 0 1 7.37-5.36M193.4 125.47l13.46-41.79a7.74 7.74 0 0 1 7.37-5.36M207.21 125.47l13.46-41.79a7.74 7.74 0 0 1 7.37-5.36M221 125.47l13.45-41.79a7.74 7.74 0 0 1 7.37-5.36",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81 97)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "choose_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#choose_svg__c"
  })), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#choose_svg__d)",
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#12186D"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.86 22.65a1.55 1.55 0 0 0-.28.2 2.29 2.29 0 0 0-1.94-.56.67.67 0 0 0-.06-.12 3.12 3.12 0 0 0-4-1.27 5.76 5.76 0 0 0-10.86-.77 5.77 5.77 0 0 0-4.36-1.61 7.38 7.38 0 0 0-9.79-2.23l-.29.18a7.35 7.35 0 0 0-5.34-.44 4.59 4.59 0 0 0-.26-.49 7.36 7.36 0 0 0-8.15-3.46 11.72 11.72 0 0 0-13.62-1.33 11.59 11.59 0 0 0-3.52 3.14 9.47 9.47 0 0 0-11.61-1.67 9.23 9.23 0 0 0-2.74 2.4 7.38 7.38 0 0 0-12.15 2.28 7.38 7.38 0 0 0-9.28-1.55 7.15 7.15 0 0 0-1 .7 5.75 5.75 0 0 0-5.92 3.63A3.12 3.12 0 0 0 6.24 21a2.24 2.24 0 1 0-.51 3.47 2.09 2.09 0 0 0 .63-.55 3.13 3.13 0 0 0 4.27 1.13c.165-.096.32-.21.46-.34a5.75 5.75 0 0 0 5.64 2.79 7.38 7.38 0 0 0 11.4-3 7.36 7.36 0 0 0 9.27 1.55 8 8 0 0 0 1.06-.74 9.46 9.46 0 0 0 12.82 3.24 9 9 0 0 0 1.71-1.27 11.72 11.72 0 0 0 20.06-.75 7.12 7.12 0 0 0 1.36-.27c.08.17.17.33.26.5a7.37 7.37 0 0 0 10.08 2.67l.28-.17a7.41 7.41 0 0 0 6.69-.12 5.75 5.75 0 0 0 8.29-2.65 5.77 5.77 0 0 0 8.6-.66 3.12 3.12 0 0 0 4.08.42 2.25 2.25 0 0 0 3.11-.36 1.9 1.9 0 0 0 2 0 1.922 1.922 0 0 0-1.92-3.33l-.02.09Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.18,
    cy: 12.16,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.02,
    cy: 11.92,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.82,
    cy: 32.91,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.34,
    cy: 2.35,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.16,
    cy: 32.69,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.96,
    cy: 9.67,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.06,
    cy: 5.85,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.36,
    cy: 17.82,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.52,
    cy: 9.35,
    r: 1.09
  })))), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M107.13 67.5h170.91v5.6H107.13z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M98.36 67.5h164.05v5.6H98.36z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    fill: "#12186D",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m253.17 69.75-18.75 56.59h-61.88v5.61h157.25v-62.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m259.76 69.75-18.74 56.59h-61.88v5.61h157.24v-62.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.54 131.94a25.31 25.31 0 0 1-12.14-6.68c-5.11-5.06-9.21-13.37-7.38-15.73 1.43-1.83 6.06.37 6.7.67 9.43 4.47 12.23 18.47 12.82 21.74",
    stroke: "#12186D",
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.54 131.94a26.88 26.88 0 0 0-6-7.87 23.93 23.93 0 0 0-4.15-3",
    stroke: "#12186D",
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.36 123.81c-.91-5.24-1.51-8.75-1.4-13.29.11-4.54 1.05-13.82 3.21-14 2.16-.18 5.25 8.12 5.68 16 .57 10.15-3.43 19.77-5.31 19.44-.81-.16-1.27-2.82-2.18-8.15Z",
    stroke: "#12186D",
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.54 131.94a34.58 34.58 0 0 0 1.51-7.63 35.47 35.47 0 0 0-.39-9",
    stroke: "#12186D",
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08 128.43c.401-1.89.603-3.818.6-5.75 0-2-.45-6-1.38-6-.93 0-2.27 3.51-2.46 6.9-.24 4.38 1.49 8.54 2.3 8.4.35-.1.54-1.25.94-3.55h0Z",
    stroke: "#12186D",
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.14 131.94a14.88 14.88 0 0 1-.48-7.17",
    stroke: "#12186D",
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.56 174.74a26.29 26.29 0 0 0-7.61-3.2l2.42-72.14h-19.58l3.46 72.1a25.94 25.94 0 0 0-7.87 3.26h12.32l-.18-3.36v-63.81h3.35l1.47 64.11-.07 3 12.29.04Z",
    stroke: "#12186D",
    fill: "#12186D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.24 75.16c0-.5 0-1-.05-1.49-.06-1.84-.13-3.55-.2-4.74-.22-3.78-3.62-5.73-4.25-6.13l-.51-.33-7.72-4.11-9.42.53-4.65 1.82c-4.24 1.61-7.58 4-7.81 7.88-.08 1.19-.14 2.89-.2 4.73 0 .5 0 1-.05 1.5a23.06 23.06 0 0 1 5.39 1.35l1.11 23.23h19.49l2.34-22.4a22.46 22.46 0 0 1 6.53-1.84h0Z",
    stroke: "#12186D",
    fill: "#55F99F",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.4 74.37c-.11 3.57-.2 7.76-.2 9.19 0 2.39 1.92 3.23 4.59 3.39 2.67.16 13.63-1 17.77-2.72.6-.26 4.48.55 4.84.3 2.06-1.42-1.59-4.46-1.59-4.46l-1.4-.06-1.93.94-1.84.12s-9.11-.72-13.67-.24l.23-6.45",
    stroke: "#12186D",
    fill: "#55F99F",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.57 81.62a9.3 9.3 0 0 1 2.39-.8",
    stroke: "#12186D",
    fill: "#55F99F",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.82 78.7a21 21 0 0 1-3.34-1 1.53 1.53 0 0 0-1.6.48 1 1 0 0 0-1 .94 1.24 1.24 0 0 0-1.09.94 1.3 1.3 0 0 0-.83.75 35.26 35.26 0 0 1 5.88-.09 11 11 0 0 1 1.61.32l.95-2.25a4.65 4.65 0 0 1-.58-.09h0Z",
    stroke: "#12186D",
    fill: "#CCC",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135 76.31.14 3.62h-.13a9.39 9.39 0 0 1 2.17 1.24L135 79.89c-2.8-.85-11-.86-13.63-1.11l-.95 2.25a31.22 31.22 0 0 1 5.29 1.94c2.28 1.21 8 3.91 11.72 3.75 3.72-.16 4.29-3.81 4.23-5.05 0-.6-.22-3.62-.44-6.79",
    stroke: "#12186D",
    fill: "#55F99F",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.56 79.12a26.84 26.84 0 0 1 2.3-2.1 10.3 10.3 0 0 1 2.37-1s2.21.08 2.57.13c.36.05.33.68-.16.71-.49.03-2 0-2 0l-1 .47h2.43s1.33.53 1.49.62c.16.09.2.69-.61.52l-1-.22 1 .61s.09.57-.58.43c-.67-.14-.83-.16-.83-.16l1 .5s.21.65-.62.46-1.68-.44-1.68-.44l-2.43-.36h-.09l-2.16-.17Z",
    stroke: "#12186D",
    fill: "#CCC",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    fill: "#CCC",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m133.69 78.16 1.56-.09.7.15M135.51 79.1l-.55-.17-1.28.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#55F99F",
    fillRule: "nonzero",
    d: "m137.01 75.07-.14.75.75.5 2.76-.45.4-.67-.31-.96-3.35.26-.16.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.05 53.58.13 4.91s-4.53 3.9-7.05 3.86C118.61 62.31 119 61 119 61v-6.16s7.21-5.38 9.05-1.26Z",
    stroke: "#12186D",
    strokeWidth: 0.25,
    fill: "#CCC",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.12 54.75a3.91 3.91 0 0 0 0 .49c.22 2.12 1.62 3.13 5.09 3a7.47 7.47 0 0 0 3.87-1.25l-.09-3.37c-1.67-3.84-7.93.46-8.87 1.13Z",
    stroke: "#12186D",
    strokeWidth: 0.25,
    fill: "#12186D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.82 48.69A1.68 1.68 0 0 1 116 47a2 2 0 0 1 2.27-1.68",
    stroke: "#12186D",
    strokeWidth: 0.25,
    fill: "#CCC",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.11 38.85a6.21 6.21 0 0 1 4.26 6.92c-.44 2.88-1 6.31-1.28 7.3-.6 2-2.52 4.06-6.89 3.58-3.18-.34-4.53-1.78-5-4.16-.47-2.38.47-6.19.63-8.69.16-2.5-.26-4.21 1.2-5.31 1.04-.78 3.97-.55 7.08.36Z",
    stroke: "#12186D",
    strokeWidth: 0.25,
    fill: "#CCC",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.13 49.81a1.67 1.67 0 0 0 2.24-1.08 2 2 0 0 0-1.7-2.24",
    stroke: "#12186D",
    strokeWidth: 0.25,
    fill: "#CCC",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.45 50.31v.15a2.092 2.092 0 1 0 4.16.45.28.28 0 0 0 0-.09l-4.16-.51Z",
    stroke: "#12186D",
    strokeWidth: 0.25,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.39 44.42a3 3 0 0 0-2.94-.94M119 43.22a2.31 2.31 0 0 1 2.41-.19",
    stroke: "#12186D",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#12186D",
    fillRule: "nonzero",
    cx: 124.81,
    cy: 46.23,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#12186D",
    fillRule: "nonzero",
    cx: 120.42,
    cy: 45.84,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.42 45.78a5.17 5.17 0 0 0-.5 1.89s-.87.12-.9.74c-.03.62 1.83.69 1.83.69",
    stroke: "#12186D",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.86 40.39a2.25 2.25 0 0 1-.9-1.94 3.33 3.33 0 0 1 2.25-2.82 2.78 2.78 0 0 1 1.09-1.26 3 3 0 0 1 2.64-.1 3.25 3.25 0 0 1 2-1 3.39 3.39 0 0 1 3.06 1.52 2.93 2.93 0 0 1 3.4 2c.167.457.229.946.18 1.43.323.136.613.341.85.6.36.407.58.919.63 1.46a3 3 0 0 1-.22 1.49 2 2 0 0 1 .86 2.06 2 2 0 0 1-1.18 1.31c.26.377.336.85.21 1.29-.31.58-.95.904-1.6.81a2 2 0 0 1-1.74-1.89 2.09 2.09 0 0 1 .51-1.41 2.61 2.61 0 0 1-.79-1.12 2.69 2.69 0 0 1-.09-1.48 4.08 4.08 0 0 1-1.79.08 4.14 4.14 0 0 1-2.23-1.25 3.74 3.74 0 0 1-2.48.37 3.64 3.64 0 0 1-1.89-1 2.28 2.28 0 0 1-2.77.85Z",
    stroke: "#12186D",
    strokeWidth: 0.25,
    fill: "#12186D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#100061",
    strokeWidth: 0.25,
    d: "M96.71 15.47h57.28v91.52H96.71z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(229 46)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "choose_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#choose_svg__e"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#choose_svg__f)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20 23)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    strokeWidth: 0.27,
    fill: "#12186D",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M96.89 77.26h5.72v1.57h-5.72z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    strokeWidth: 0.27,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M82.12 77.26h14.77v1.57H82.12z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    strokeWidth: 0.27,
    fill: "#12186D",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M93.52 71.3h2.11v5.9h-2.11z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    strokeWidth: 0.27,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M88.06 71.3h5.45v5.9h-5.45z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    strokeWidth: 0.27,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M105.56 72.69H66.38l18.03-17.58h39.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M105.56 72.69H66.38l18.03-17.58h39.18z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#12186D",
    strokeWidth: 0.27,
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105 54.14 84.63 73.99M79.8 58.69h42.5M76.17 62.22h42.5M72.55 65.76h42.5M68.92 69.29h42.5"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    strokeWidth: 0.27,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M105.56 72.69H66.38l18.03-17.58h39.18z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    strokeWidth: 0.27,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M66.38 72.69h39.25v.61H66.38z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    strokeWidth: 0.27,
    fill: "#12186D",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M123.59 55.11v.68L105.63 73.3v-.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#55F99F",
    fillRule: "nonzero",
    d: "M123.59 55.89H84.41L66.38 73.47v.61h39.25l17.96-17.51z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    strokeWidth: 0.31,
    fill: "#12186D",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M68.34 77.04h6.52v1.79h-6.52z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    strokeWidth: 0.31,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M51.5 77.04h16.84v1.79H51.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    strokeWidth: 0.31,
    fill: "#12186D",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M64.49 70.25h2.41v6.73h-2.41z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    strokeWidth: 0.31,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M58.27 70.25h6.22v6.73h-6.22z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    strokeWidth: 0.31,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M78.23 71.82H33.54l20.57-20.04h44.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M78.23 71.82H33.54l20.57-20.04h44.68z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#12186D",
    strokeWidth: 0.31,
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.59 50.67 54.36 73.31M48.85 55.86h48.46M44.71 59.89h48.47M40.58 63.92h48.46M36.44 67.95h48.47"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    strokeWidth: 0.31,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M78.23 71.82H33.54l20.57-20.04h44.68z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    strokeWidth: 0.31,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M33.54 71.83H78.3v.7H33.54z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    strokeWidth: 0.31,
    fill: "#12186D",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M98.79 51.78v.77L78.3 72.52v-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#55F99F",
    fillRule: "nonzero",
    d: "M98.79 52.67H54.11L33.54 72.72v.69H78.3l20.49-19.97z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    strokeWidth: 0.34,
    fill: "#12186D",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M38.1 76.88h7.13v1.96H38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    strokeWidth: 0.34,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.7 76.88h18.4v1.96H19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    strokeWidth: 0.34,
    fill: "#12186D",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M33.9 69.45h2.63v7.35H33.9z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    strokeWidth: 0.34,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M27.11 69.45h6.79v7.35h-6.79z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    strokeWidth: 0.34,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M48.9 71.18H.09l22.47-21.9h48.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M48.9 71.18H.09l22.47-21.9h48.81z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#12186D",
    strokeWidth: 0.34,
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.2 48.07 22.83 72.8M16.81 53.74h52.94M12.29 58.14h52.94M7.78 62.55h52.94M3.26 66.95H56.2"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    strokeWidth: 0.34,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M48.9 71.18H.09l22.47-21.9h48.81z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    strokeWidth: 0.34,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M.09 71.18h48.89v.76H.09z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    strokeWidth: 0.34,
    fill: "#12186D",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M71.37 49.28v.84L48.99 71.94v-.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#55F99F",
    fillRule: "nonzero",
    d: "M71.37 50.26H22.56L.09 72.15v.76h48.9L71.37 51.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#12186D",
    strokeWidth: 0.17,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x: 50.96,
    y: 77.37,
    width: 1.8,
    height: 1.19,
    rx: 0.59
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7.77S56.85-.07 59.77 3c2.42 2.56 3.25 4.23 3.39 7.55.14 3.32 2.09 11 3.72 15a4.08 4.08 0 0 1-1.53-.6s2.26 7.37-.54 11.25c-4.62 6.43-12.73 6.9-15.28 6.38-2.55-.52-6.45-4-7.82-7.79s1.85-11.16 2.05-14.09c.2-2.93-.25-2.69-1-5.89-.75-3.2-.14-14.68 7.94-14.04Z",
    fill: "#12186D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#12186D",
    strokeWidth: 0.53,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.24 30.69 35 14.2a3.75 3.75 0 0 0 .64-.43 4.42 4.42 0 0 0 1.14-1.54 10 10 0 0 1 .57-1.47c.112-.271.308-.5.56-.65.17-.08.33-.09.46-.26a.52.52 0 0 0 .1-.39.56.56 0 0 0-.08-.18.69.69 0 0 0-.51-.23 1.78 1.78 0 0 0-1.17.39 2.22 2.22 0 0 0-.7.87 7.76 7.76 0 0 0 .21-1c0-.31.06-.6.07-.86V4.58a.48.48 0 0 0-.14-.32.43.43 0 0 0-.63-.01.66.66 0 0 0-.08.31s-.24 3.46-.31 3.68c-.07.22-.15 0-.15 0a27.89 27.89 0 0 0 .14-4.31.57.57 0 0 0-.2-.36.5.5 0 0 0-.42-.09.5.5 0 0 0-.3.2.51.51 0 0 0-.11.33s-.22 3.46-.27 3.75c-.05.29-.18 0-.18 0V4.8s0-.36-.46-.46c-.46-.1-.48.46-.48.46 0 .6-.18 3-.19 3.07-.01.07 0 0 0 0l-.11-.08a21.12 21.12 0 0 0-.15-2.33.39.39 0 0 0-.48-.22c-.33.15-.28.62-.28.62-.07 1.45-.11 2.95-.12 4.48v2.67c0 .15-.11 1.31-.11 1.31v.62c-.09 1.46-1 15.41-.82 17.5.18 2.09 1.08 3.54 3.56 3.85.79.1 3.08.21 5.87.31l.56-6.49-5.19.58Z",
    fill: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.33 28.88-12 1.27-.56 6.49c6 .22 13.65.17 14.6 0a17.42 17.42 0 0 0 3.86-1.58",
    fill: "#55F99F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.51 44.44c.55-2.69 2.39-12.57 1.65-14.18-.74-1.61-1.78-1.47-4.4-2.27s-7-.9-9 0-4.14 4.84-5.77 6.89-2.83 4.42-1.92 6.56a7.72 7.72 0 0 0 2.82 3.27v9.89h15.45c-.04-.2.66-7.5 1.17-10.16h0Z",
    fill: "#55F99F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.46 64.56a32.27 32.27 0 0 0-3.18-10H44.83v10h18.63Z",
    fill: "#12186D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.83 37 9.8 7 4.73-4.48c-4.34-4.14-10.1-9.18-10.91-9.7a16.91 16.91 0 0 0-3.94-1.38",
    fill: "#55F99F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.54 43.66c-.52-.59-2.15-2.19-4.18-4.12L70.63 44l4.19 3s-9.37 12.87-10.13 13.3c-.76.43-3.09-.67-3.31-1.07a1.41 1.41 0 0 0-1.14-.57c-.23.05-.38.57.46 1.15l.23.12s-2.73.05-3.21.58c0 0-1 .32-1 .58 0 0-1.43.39-.79 1 .64.61 3.57.07 4.54.46.97.39 2.17 1.57 3.38 1.49 1.21-.08 2.56-1.56 3.59-2.59 1.03-1.03 11-10.87 12.22-12.55 1.22-1.68 1.53-3.36-.12-5.24h0ZM55.36 17.82c.19.12 0 9.21 0 11.05 0 1.84-5.52 7.08-6.32 6.86-.8-.22.22-6.67 1.3-8.25v-9.41l5.02-.25Z",
    fill: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m50.15 19.42 5.54.28v5.09a5.2 5.2 0 0 1-4.38 1.49 3.67 3.67 0 0 1-1.22-.29c-.04-3.19-.09-6.49.06-6.57Z",
    fill: "#12186D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.7 163.57 1.94.44 1.95-65.53H47c1 27.21 2.7 65.09 2.7 65.09ZM55.76 98.48l3.81 65.2h1.81s1.21-39.62 1.86-65.2h-7.48Z",
    stroke: "#12186D",
    strokeWidth: 0.53,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.46 64.56H44.81s-.87 1.86-1.5 7c-.21 1.75.23 12.92.91 26.91h21.13c.3-9.3.51-16.74.51-19.75 0-11.3-2.4-14.16-2.4-14.16ZM44.33 164.36h7.61v-2.23h-2.69a22.76 22.76 0 0 0-4.92 2.23ZM54.23 164.36h7.61v-2.23h-2.69a22.76 22.76 0 0 0-4.92 2.23Z",
    stroke: "#12186D",
    strokeWidth: 0.53,
    fill: "#12186D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.61 25.06c.45.31 7-1.32 8.68-5.72 1.68-4.4 3.36-12.69-2.81-15-6.17-2.31-8.4.55-10.2 5.5-1.8 4.95-.86 11.73 4.33 15.22Z",
    stroke: "#12186D",
    strokeWidth: 0.53,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.54 7.58s-5.82 6.43-15.64 1.71c0 0 2.25-6.42 7-7.65 3.21-.81 9.42-.9 8.64 5.94Z",
    fill: "#12186D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.52 6.16a29.5 29.5 0 0 1 2.84 9.57s4-3.47 2.15-6.77c-1.85-3.3-1.43-4.92-3.19-5-1.76-.08-1.8 2.2-1.8 2.2Z",
    fill: "#12186D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.73 16.78a1.91 1.91 0 0 1-1.09-.21 2.34 2.34 0 0 0 .54-1.81",
    stroke: "#12186D",
    strokeWidth: 0.53,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.44 19.48a2 2 0 0 0 .25.61 2.1 2.1 0 0 0 3.82-1.62l-4.07 1.01Z",
    stroke: "#12186D",
    strokeWidth: 0.53,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.16 12a1 1 0 0 1 .55-.44 1 1 0 0 1 .77.12M51.29 11.62a1 1 0 0 1 .69-.09 1 1 0 0 1 .6.5",
    stroke: "#12186D",
    strokeWidth: 0.79,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#12186D",
    fillRule: "nonzero",
    cx: 51.65,
    cy: 14.26,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#12186D",
    fillRule: "nonzero",
    cx: 47.14,
    cy: 14.19,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.69 5.55s-1.93 6.37 3.78 7.25c5.71.88.5-5.54.5-5.54l-3.3-1.93-.92.11-.06.11Z",
    fill: "#12186D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.29 16a2 2 0 0 0 1.76.5 2.08 2.08 0 0 0 1.25-1.63 2 2 0 0 0-.06-1.26 1.62 1.62 0 0 0-1.13-1 1.53 1.53 0 0 0-1.19.31",
    stroke: "#12186D",
    strokeWidth: 0.53,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M229.88 46.47h57.28v91.52h-57.28z"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#12186D",
    fontFamily: "Helvetica",
    fontSize: 10.57,
    transform: "translate(163 25)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 85.53,
    y: 34.15
  }, "ELS")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(163 46)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "choose_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#choose_svg__g"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#choose_svg__h)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-50)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#12186D"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.36,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m90.9 30.6-3.61-.16-.02 7.32h3.83zM91.25 42.81h-3.99l-.01 4.41h4.13zM87.13 90.97l5.5-.08-.84-29.16h-4.58zM91.52 52.27h-4.29l-.01 4.41h4.43z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.36,
    fill: "#12186D",
    fillRule: "nonzero",
    d: "m87.22 56.68-.01 5.05h4.58l-.14-5.05zM91.38 47.22h-4.13l-.02 5.05h4.29zM91.1 37.76h-3.83l-.01 5.05h3.99z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.36,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M85.97 90.81h7.83v7.75h-7.83z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8 8.13a23 23 0 0 1 12.71 16.56M67 27.38c0-.32 0-.63.08-.94M68.06 35.81A22.91 22.91 0 0 1 67 29.66M74.8 46.12a23.12 23.12 0 0 1-5.89-8.06M98.6 50.12a23 23 0 0 1-22.36-2.84",
    strokeWidth: 0.42,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.18 38.69a2.06 2.06 0 0 0-2-2.07H53a2.58 2.58 0 0 0-1.89-.83 2.52 2.52 0 0 0-1.31.36 2.57 2.57 0 0 0-5-.24 2 2 0 0 0-2.06 0 2.11 2.11 0 0 0-1.28-1.31 2.07 2.07 0 0 0-2-1.61h-.28a3.65 3.65 0 0 0-6.22.49 3.65 3.65 0 0 0 .27 7.29h23.92a2.06 2.06 0 0 0 2.03-2.08h0ZM58.19 48.43h5a1.44 1.44 0 0 0 0-2.87 1.44 1.44 0 0 0-2.84-.15 1.08 1.08 0 0 0-.68-.24 1.1 1.1 0 0 0-1.1 1.1 1 1 0 0 0 .1.43 1 1 0 0 0-.46-.12.93.93 0 0 0 0 1.85h-.02ZM104.83 46.15a.9.9 0 0 0-.9-.9.93.93 0 0 0-.44.12 1.05 1.05 0 0 0-.97-1.48 1.1 1.1 0 0 0-.66.23A1.38 1.38 0 0 0 100.5 43a1.39 1.39 0 0 0-1.38 1.27 1.39 1.39 0 0 0 0 2.77H104a.9.9 0 0 0 .83-.89h0Z",
    strokeWidth: 0.27,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.36,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m88.77 30.49.53 5.67-14.91 23.7-1.5-.08L87.76 29.6zM88.33 28.69l-5.18-2.35-13.2-24.7.81-1.26 18.85 27.87z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#55F99F",
    fillRule: "nonzero",
    d: "m88.29 30.01.53 5.67-14.91 23.7-1.5-.08 14.87-30.18zM88.97 28.48l-5.18-2.35-13.2-24.7.82-1.26 18.84 27.87z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    strokeWidth: 0.36,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m90.06 28.34 4.68-3.25 27.97 1.28.67 1.34-33.59 1.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#55F99F",
    fillRule: "nonzero",
    d: "m89.96 27.92 4.67-3.26 27.97 1.28.67 1.34-33.59 1.96z"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#12186D",
    strokeWidth: 0.36,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 89.14,
    cy: 29.03,
    r: 2.43
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.73 61.13 3.46-2.54s3.6 4.94 3.64 4.85c.04-.09-.67 1.86-.67 1.86h-3c-.13 0-2.28.59-2.28.59",
    stroke: "#12186D",
    strokeWidth: 0.5,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.53 170.72a1.49 1.49 0 0 1-1.49-1.49 1.48 1.48 0 0 1 .44-1 1.44 1.44 0 0 1 1.05-.44c30.39-.06 68.5-.84 77.48-4.2 8.78-3.29 12-9.19 12-21.76l-.17-87.72a1.51 1.51 0 0 1 .43-1.06 1.5 1.5 0 0 1 2.55 1l.17 87.72c0 6.89-.94 11.87-3 15.66-2.21 4.1-5.69 6.93-11 8.9-9.4 3.52-47.89 4.33-78.52 4.39h.06Z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.34 52.81a1.25 1.25 0 0 1 1.24 1.24l.17 87.72c0 6.85-.92 11.79-2.95 15.55-2.18 4-5.62 6.83-10.83 8.78-9.36 3.5-47.82 4.31-78.44 4.37a1.24 1.24 0 0 1 0-2.48c30.41-.06 68.56-.84 77.57-4.22 9.01-3.38 12.19-9.29 12.17-22l-.17-87.72c0-.33.129-.646.36-.88a1.3 1.3 0 0 1 .88-.37v.01Zm0-.5a1.74 1.74 0 0 0-1.74 1.74l.17 87.72c0 12.45-3.19 18.29-11.84 21.53-9.21 3.45-49.46 4.13-77.4 4.18a1.74 1.74 0 0 0 0 3.48c28.36-.06 68.9-.77 78.6-4.41 5.33-2 8.86-4.86 11.1-9 2.06-3.83 3-8.85 3-15.78l-.17-87.72a1.73 1.73 0 0 0-1.74-1.73l.02-.01Z",
    fill: "#12186D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.347 55.8a5.19 5.19 0 0 1-5.2-5.18l-.006-3.29 10.38-.02.006 3.29a5.19 5.19 0 0 1-5.18 5.2h0Z",
    stroke: "#12186D",
    strokeWidth: 0.5,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.33 46.79c-2.19 0-4.06.54-4.82 1.29a1.06 1.06 0 0 1-.37-.76c0-1.13 2.32-2 5.18-2s5.19.9 5.2 2a1.06 1.06 0 0 1-.37.76c-.77-.77-2.64-1.3-4.82-1.29h0Z",
    stroke: "#12186D",
    strokeWidth: 0.5,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#12186D",
    strokeWidth: 0.5,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "rotate(-.11 95.334 48.07)",
    cx: 95.334,
    cy: 48.07,
    rx: 4.82,
    ry: 1.29
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#12186D",
    fillRule: "nonzero",
    transform: "rotate(-.11 97.145 48.346)",
    cx: 97.145,
    cy: 48.346,
    rx: 1.01,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#12186D",
    fillRule: "nonzero",
    transform: "rotate(-.11 93.435 48.363)",
    cx: 93.435,
    cy: 48.363,
    rx: 1.01,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.39 59.51 1.63-2.86 2.24.33 2.19-.13a1.5 1.5 0 0 1-1.36 1.71c-1.53.12-2.07.12-2.07.12s0 2.57-1.81 3.27",
    stroke: "#12186D",
    strokeWidth: 0.5,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#12186D",
    strokeWidth: 0.5,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "rotate(3.12 96.65 59.16)",
    x: 94.945,
    y: 58.549,
    width: 3.41,
    height: 1.22,
    rx: 0.57
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#12186D",
    strokeWidth: 0.5,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "rotate(3.12 96.828 60.577)",
    x: 95.048,
    y: 59.967,
    width: 3.56,
    height: 1.22,
    rx: 0.58
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#12186D",
    strokeWidth: 0.5,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "rotate(3.12 96.818 62.044)",
    x: 95.038,
    y: 61.434,
    width: 3.56,
    height: 1.22,
    rx: 0.58
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#12186D",
    strokeWidth: 0.5,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "rotate(3.12 96.616 63.356)",
    x: 94.856,
    y: 62.751,
    width: 3.52,
    height: 1.21,
    rx: 0.57
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.14 60 2.25 5.93L81 73.53a5.18 5.18 0 0 1-7.89-3L67 47.31l10.78-3.8 3.13 20.68L90.14 60Z",
    stroke: "#12186D",
    strokeWidth: 0.48,
    fill: "#55F99F",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.26 80.64c-.14-1.59-.18-4.93-.44-7.85-1-11.63-.79-10.94-1-12.07-1.63-7.24-5.14-10.49-3.26-14.23a6.15 6.15 0 0 1 1.14-1.56s.25-.28.54-.54a19.94 19.94 0 0 1 3.14-2.25c1.47-.83 3.36-1.9 5.64-3.12a30.61 30.61 0 0 1 4.42-.21c3.29.09 6.545.69 9.65 1.78a14.63 14.63 0 0 1 3.3 1.19 6.41 6.41 0 0 1 2.45 1.73 5.17 5.17 0 0 1 1 3.11c.11 2.65-.68 12.28-2.21 25.23.09.74.64 6.06-3.12 9.65-3.18 3-7.36 2.82-9.92 2.69C58 83.9 53.94 82 52.26 80.64h0Z",
    stroke: "#12186D",
    strokeWidth: 0.48,
    fill: "#55F99F",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 41.15v.16c-.28-.23-.62-.48-.72-.39-.1.09 0 .26 0 .31",
    fill: "#12186D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.27 40.35a7.29 7.29 0 0 1-1.86 0A8.08 8.08 0 0 1 63.9 39",
    stroke: "#12186D",
    strokeWidth: 0.53,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 110.34a.48.48 0 0 0-.5.4c-1.63 19-2.33 31.5-1.9 36.9 0 .22.05.55.07.93h5.27l-2.48-37.77a.46.46 0 0 0-.46-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.55 148v.53h.11c0-.38 0-.71-.07-.93l-.04.4ZM64.54 148.38v.19-.19ZM64.55 148v-.4.4ZM64.44 150.23l.08-1.51-.11 2.17z",
    fill: "#12186D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.07 150.34 77 55.47s-18.12 1.63-18 1.85c.12.22 1.59 24.18 1.59 24.18l-8.37-.86 3.39 67.89h8.77l2.24-45.62 3.76 47.29 8.69.14Z",
    stroke: "#12186D",
    strokeWidth: 0.43,
    fill: "#12186D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.28 60s-4.24-13.39-7.43-18.11l1.81-1s8 14.36 8.43 18.81l-2.81.3ZM74.45 56.75c-.08 0-1-15.69-1-15.69l1.67.4 1.39 14.89-2.06.4Z",
    stroke: "#12186D",
    strokeWidth: 0.43,
    fill: "#12186D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.15 152.52.13 1.7 3.45.1 1-.93 1.1 1s9.24 1.66 10.12-2a7.37 7.37 0 0 1-2.87.58 119.16 119.16 0 0 1-12.93-.45h0Z",
    stroke: "#12186D",
    strokeWidth: 0.41,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.17 146.51 79 132.76l-10.35.28 1.51 19.48c4.292.377 8.602.52 12.91.43a7.37 7.37 0 0 0 2.87-.58v-.06c.3-1.42-6.77-5.8-6.77-5.8Z",
    stroke: "#12186D",
    strokeWidth: 0.48,
    fill: "#55F99F",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.69 152.77.13 1.7 3.44.09 1-.93 1.1 1s9.23 1.65 10.12-2.06a7.46 7.46 0 0 1-2.87.58c-4.31.1-8.623-.026-12.92-.38Z",
    stroke: "#12186D",
    strokeWidth: 0.41,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.71 146.76 1-13.6-11.57.13 1.51 19.48c4.293.367 8.602.507 12.91.42a7.46 7.46 0 0 0 2.87-.58.43.43 0 0 1 0-.05c.35-1.42-6.72-5.8-6.72-5.8h0Z",
    stroke: "#12186D",
    strokeWidth: 0.48,
    fill: "#55F99F",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.52 34.34a10.52 10.52 0 0 1-.55 3.33 4.45 4.45 0 0 1-1 1.21c-.24.16-.45.31-.62.45a23.73 23.73 0 0 0 2.13 2.46 25.4 25.4 0 0 0 3.45 2.95 33.71 33.71 0 0 0 4.47 2.57c.17-1.19.38-2.81.6-4.72.11-.91.18-1.59.22-2.11-4.4.52-7.52-4.48-8.7-6.14h0Z",
    stroke: "#12186D",
    strokeWidth: 0.53,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.76 39.47c.215.512.497.993.84 1.43a4.27 4.27 0 0 0 1.78 1.49 3.54 3.54 0 0 0 1.66.2l.23-2.24a7.29 7.29 0 0 1-1.86 0 8 8 0 0 1-2.65-.86",
    stroke: "#12186D",
    strokeWidth: 0.52,
    fill: "#12186D",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.18 25.25a7.22 7.22 0 0 0-3.07-3.92c-3-1.59-6.38.25-7.1.64-.72.39-3.3 1.78-3.94 4.35-.1.43-.2 1.08.45 4.55.35 1.87.71 3.41 1 4.51.072.268.118.543.14.82 4.41 5.39 8.23 4.21 9.13 4a5 5 0 0 0 2.62-1.39c.49-.5 1-1.32 1.3-5.32.3-4 .41-6.05-.53-8.24h0Z",
    stroke: "#12186D",
    strokeWidth: 0.53,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    strokeWidth: 0.49,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m69.63 30.21 1.19 4.33-1.96.15"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#12186D",
    fillRule: "nonzero",
    cx: 66.98,
    cy: 30.94,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#12186D",
    fillRule: "nonzero",
    cx: 71.58,
    cy: 30.94,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.78 29.94c0-.07.05-.07.05-.08.09-.107.19-.204.3-.29a2.12 2.12 0 0 1 1.46-.41c.64 0 .64-1 0-1a2.94 2.94 0 0 0-2.66 1.27.493.493 0 0 0 .85.5v.01ZM70.61 29a2 2 0 0 1 1.9.49c.48.42 1.18-.28.7-.7a3 3 0 0 0-2.86-.74c-.59.22-.34 1.17.26 1V29Z",
    fill: "#12186D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8 32.26a8.53 8.53 0 0 0 2.31-1c1.29-.82 1.67-1.58 3.07-2.65a13.5 13.5 0 0 1 2.24-1.38c-1.71-.1-3.54-.14-5.48-.08-1.05 0-2.07.08-3.05.15.11.87.24 1.79.42 2.75.15.78.31 1.52.49 2.22",
    stroke: "#12186D",
    strokeWidth: 0.1,
    fill: "#12186D",
    fillRule: "nonzero",
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.07 30.5A1.83 1.83 0 0 0 61 32a1.85 1.85 0 0 0 2.18 1.62",
    stroke: "#12186D",
    strokeWidth: 0.53,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.76 39.38a3.25 3.25 0 0 1-.87-.65 4.05 4.05 0 0 1-.76-1.11 7.2 7.2 0 0 1-.41-2.53c-.05-.81-.06-1.47-.07-1.92.317.255.651.49 1 .7a11.63 11.63 0 0 0 6.93 1.4 12.66 12.66 0 0 0 3-.64 8.65 8.65 0 0 1-.31 2.14 4.48 4.48 0 0 1-.89 2 3.92 3.92 0 0 1-1.26.88 6.58 6.58 0 0 1-2.79.64 7.5 7.5 0 0 1-3.57-.91Z",
    fill: "#12186D",
    fillRule: "nonzero",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.84 36.66a.51.51 0 0 1 0 .13 1.93 1.93 0 1 1-3.77-.8.29.29 0 0 0 0-.09l3.77.76Z",
    stroke: "#12186D",
    strokeWidth: 0.49,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.77 28.66c2.81-.13 5.2-.37 7-.6 0 0 2.26-.29 9.28-2.73a2.5 2.5 0 0 0 1.61-1.28 1.87 1.87 0 0 0-.14-1.78 1.47 1.47 0 0 0-1.09-.46l-3.86-.49c-1.14-.15-1-.31-2.45-.6a18.1 18.1 0 0 0-5.47-.21c-2.09.26-3.13.38-3.89 1.07-2.11 1.98-1.12 6.51-.99 7.08Z",
    stroke: "#12186D",
    strokeWidth: 0.1,
    fill: "#12186D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.63 34.6a7.53 7.53 0 0 1-.48 3.29l4.53 2-2.44-4.28-1.56-1.06",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.25 91.19 2.06 1.26 1.33-.26a1 1 0 0 1 1.11.71l.06.24-2.33.54-2.77-1.22",
    stroke: "#12186D",
    strokeWidth: 0.5,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.23 84.44c.05.28.07.45.07.45.94.13 1.41 3.47 1.47 3.74.06.27.73 1.54 1 2.25.23.406.23.904 0 1.31-.15.24-.67-.16-1.17-1.11-.5-.95-.89-1.34-.82-1.18.07.16 0 2.18 0 2.18a21.28 21.28 0 0 0 2.19 1.65c.88.53 1.45.73 1.17 1.3-.28.57-1.89-.29-2.36-.46a8.12 8.12 0 0 1-3.38-3.52 16.79 16.79 0 0 1-1.16-5.81",
    stroke: "#12186D",
    strokeWidth: 0.5,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.86 42s-6.63 2.46-7.24 7.47c-.55 4.43-1.48 13.1-1.61 15.68a14.82 14.82 0 0 0 0 2.73l2.23 18.57 5.23-1.18-1.85-17.57 3.63-13.22",
    stroke: "#12186D",
    strokeWidth: 0.48,
    fill: "#55F99F",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#12186D",
    fontFamily: "Helvetica",
    fontSize: 7.77
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.36,
    y: 162.96
  }, "6."))))), /*#__PURE__*/React.createElement("path", {
    stroke: "#12186D",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M163.2 46.47h57.28v91.52H163.2z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#12186D",
    fontFamily: "Helvetica",
    fontSize: 10.57
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(180.57 49.15)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 10
  }, "J")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(180.57 49.15)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 4.3,
    y: 10
  }, "AN"))), /*#__PURE__*/React.createElement("path", {
    stroke: "#55F99F",
    strokeWidth: 1.98,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M163.65 33.43v-4.31l1.98-1.81 1.97-1.81 1.99 1.81 1.98 1.81v4.31zM171.57 37.74v-4.31h7.93v4.31l-1.99 1.81-1.97 1.81-2-1.81z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1D1973",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.42 35.51c0 2.23-1.51 3.37-4.44 3.37h-7.51V26.75h7.26c2.84 0 4.3 1.11 4.3 3.27a2.56 2.56 0 0 1-1.87 2.64 2.72 2.72 0 0 1 2.26 2.85Zm-9.17-3.92h4.43c1.07 0 1.58-.4 1.58-1.2 0-.8-.51-1.25-1.55-1.25h-4.46v2.45Zm6.34 3.64c0-.84-.56-1.25-1.66-1.25h-4.68v2.51H194c1.05 0 1.59-.41 1.59-1.26ZM200.58 34.37c0-2.84 2.07-4.73 5.17-4.73s5.18 1.89 5.18 4.73c0 2.84-2.07 4.73-5.18 4.73s-5.17-1.89-5.17-4.73Zm7.62 0a2.45 2.45 0 1 0-2.45 2.51 2.32 2.32 0 0 0 2.45-2.51ZM213.5 26.22h2.67v12.66h-2.67zM226.65 38.54a5.7 5.7 0 0 1-2.63.56c-2.32 0-3.44-.93-3.44-2.84v-4.39h-2.18v-2h2.18v-3.12h2.68v3.11h3.15v2h-3.15v3.82c0 .86.37 1.19 1.3 1.19a3.51 3.51 0 0 0 1.62-.39l.47 2.06Z"
  })))));
};

export default SvgChoose;